import React from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { Z_INDEX_LAYERS } from '../../../labelling/constants';
import { selectedVideoIndexAtom } from '../../atoms/multi-video-atoms';
const OverlayContainer = styled('div', () => ({
  position: 'relative',
  display: 'flex',
  flex: 1,
  width: '100%'
}));
const DisabledOverlay = styled('div', () => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'transparent',
  zIndex: Z_INDEX_LAYERS.FIVE,
  cursor: 'not-allowed',
  pointerEvents: 'all'
}));
type SidePanelOverlayProps = {
  children: React.ReactNode;
};
export const SidePanelOverlay: React.FC<SidePanelOverlayProps> = ({
  children
}) => {
  const selectedVideoIndex = useAtomValue(selectedVideoIndexAtom);
  const isMainView = selectedVideoIndex === 0;
  return <OverlayContainer>
      {children}
      {!isMainView && <DisabledOverlay data-testid="disabled-overlay" />}
    </OverlayContainer>;
};